import React, { useEffect } from "react";
import SEO from "../components/SEO";
import FAQ from "../components/FAQ";

const policiesData = [
  {
    id: 1,
    title: "Investor Redressal Mechanism Policy",
    file: "Policy on redressal mechanism for investor grievances_GFSL.pdf",
  },
  {
    id: 2,
    title: "PMLA Policy",
    file: "Prevention_of_Money_Laundering_Policy_GFSL.pdf",
  },
  {
    id: 3,
    title: "Conflict of Interest Policy",
    file: "Conflict_of_interest_policy_GFSL.pdf",
  },
  { id: 4, title: "Error Code Policy", file: "Error_Code_Policy_GFSL.pdf" },
  {
    id: 5,
    title: "Policy for Inactive Clients",
    file: "Policy_on_Inactive_Client_GFSL.pdf",
  },
  {
    id: 6,
    title: "Cyber Security Policy",
    file: "Policy_on_Cyber_Security_and_Cyber_Resilience_GFSL.pdf",
  },
  { id: 7, title: "Surveillance Policy", file: "Surveillance_Policy_GFSL.pdf" },
  { id: 8, title: "RMS Policy", file: "Client RMS Policy_GFSL.pdf" },
  {
    id: 9,
    title:
      "Policy on Introduction & Registration of Clients including IPV & Policy on Onboarding of New clients & Policy on acceptance of clients.",
    file: "Policy on introduction registration of clients including IPV policy on onboarding of new clients policy on acceptance of clients_GFSL.pdf",
  },
  {
    id: 10,
    title: "Policy on Pre funded Instruments and EFT",
    file: "Policy_on_Prefunded_Instruments_GFSL.pdf",
  },
  {
    id: 11,
    title: "Policy on Identification of Beneficial Ownership",
    file: "Policy_on_Identification_of_Beneficial_Ownership_GFSL.pdf",
  },
  {
    id: 12,
    title: "Policy on Code of Conduct for Employees",
    file: "Policy_on_Code_of_Conduct_for_Employees_GFSL.pdf",
  },
  {
    id: 13,
    title: "Policy on Client Code Modification",
    file: "Policy_on_Client_Code_Modification_GFSL.pdf",
  },
  {
    id: 14,
    title: "Policy on Debit Balance Exposure",
    file: "Policy_on_Debit_Balances_GFSL.pdf",
  },
  {
    id: 15,
    title: "Limit Setting Policy",
    file: "Policy_on_limit_setting_GFSL.pdf",
  },
  {
    id: 16,
    title: "Internal Shortage Policy",
    file: "Policy_on_Internal_Shortage_GFSL.pdf",
  },
  {
    id: 17,
    title: "NISM Series-VII SORM Policy",
    file: "Policy-w.r.t-NISM-Series-VII-Securities-Operation-Risk-Management-SORM_GFSL.pdf",
  },
  {
    id: 18,
    title: "Code of Conduct for Prevention of Insider Trading",
    file: "Policy_on_prevention_of_insider_trading_GFSL.pdf",
  },
  {
    id: 19,
    title: "Prohibition on Circulation of Unauthenticated News",
    file: "Policy_on_Circulation_of_Unauthenticated_News_GFSL.pdf",
  },
  {
    id: 20,
    title: "Margin Trading Facility Policy",
    file: "Margin_trading_Facility_Policy_GFSL.pdf",
  },
  {
    id: 21,
    title:
      "Policy regarding the use of facsimile scanned signatures for Physical contract notes",
    file: "Policy Regarding the use of fascimile scanned signatures for physical contract notes_GFSL.pdf",
  },
  {
    id: 22,
    title: "Policy on Compliance Officer",
    file: "Policy_on_compliance_officer_GFSL.pdf",
  },
  {
    id: 23,
    title: "Policy on Internal Control System",
    file: "Policy_on_Internl_Control_GFSL.pdf",
  },
  { id: 24, title: "Referral Policy", file: "Referal_Policy_GFSL.pdf" },
  {
    id: 25,
    title: "Maintenance and Preservation of Records Policy",
    file: "Policy for maintainance and preservation of records_GFSL.pdf",
  },
  {
    id: 26,
    title: "Policy on Guidelines for Outsourcing of Activities",
    file: "Outsourcing_Policy_GFSL.pdf",
  },
  {
    id: 27,
    title: "Policy on GTC/GTD",
    file: "Policy_on_GTD and GTC_GFSL.pdf",
  },
];

const Policies = () => {
  useEffect(() => {
    if (window.jQuery) {
      const $ = window.jQuery;
      if ($.fn.tab) {
        $(".tab1").tab();
        $(".tab2").tab({ trigger_event_type: "mouseover" });
      }
    }
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="page-content">
      <SEO
        title="Corporate Policies & Regulatory Disclosures"
        description="Comprehensive list of corporate policies, investor redressal mechanisms, RMS, and PMLA policies. Ensuring transparency and regulatory compliance at Gateway Financial."
      />
      <section id="banner-slider" className="inn-banner-slider">
        <div
          id="carouselExampleIndicators"
          className="carousel slide"
          data-ride="carousel"
        >
          <div className="carousel-inner" role="listbox">
            <div
              className="carousel-item active"
              style={{ backgroundImage: "url('/images/other-banner.png')" }}
            >
              <canvas id="canvas"></canvas>
              <div className="carousel-caption">
                <h1>Policies</h1>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="welcome-section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-12 text-center">
              <table className="table dwn-tbl table-bordered">
                <thead className="thead-dark">
                  <tr>
                    <th scope="col" width="80px">
                      Sr. No.
                    </th>
                    <th scope="col" className="text-left">
                      Descriptions
                    </th>
                    <th scope="col">Downloads</th>
                  </tr>
                </thead>
                <tbody>
                  {policiesData.map((policy) => (
                    <tr key={policy.id}>
                      <td>{policy.id}</td>
                      <td className="text-left">{policy.title}</td>
                      <td>
                        <a
                          href={`pdf/${policy.file}`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <i className="fa fa-download" aria-hidden="true"></i>
                        </a>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>

      <section id="app-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 align-self-center">
              <h3>Download our Investment Fund App</h3>
              <p>Investing With Gateway Financial Services Limited</p>
              <a href="#download" className="lm-btn">
                download &amp; explore more
              </a>
            </div>
            <div className="col-lg-6">
              <img src="images/app-pic.jpg" className="img-fluid" alt="App" />
            </div>
          </div>
        </div>
      </section>

      <FAQ />
    </div>
  );
};

export default Policies;
